import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WEEKDAY } from '../models/enums';

@Pipe({
  name: 'weekdayFormatter',
  pure: false,
})
export class WeekdayFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(d: Date, isShortFormat?: boolean): string {
    if (!d) {
      return null;
    }

    const weekdayAsStr = [
      WEEKDAY.SUNDAY,
      WEEKDAY.MONDAY,
      WEEKDAY.TUESDAY,
      WEEKDAY.WEDNESDAY,
      WEEKDAY.THURSDAY,
      WEEKDAY.FRIDAY,
      WEEKDAY.SATURDAY,
    ];

    const matchedWeekdayStr = weekdayAsStr[d.getDay()];

    return this.translateService.instant(
      isShortFormat
        ? `pipes.weekday_short.${matchedWeekdayStr}`
        : `pipes.weekday.${matchedWeekdayStr}`
    );
  }
}
